import { Image } from 'antd';
import React from 'react';
import { Icon } from '../styles/commonStyle';

/**
 * ImageBox - 이미지 표시 및 관리 컴포넌트
 *
 * @description 90x90 크기의 정사각형 이미지 박스로, 클릭 시 확대보기 기능과 선택적 삭제 기능을 제공합니다.
 *
 *
 * @param {Object} props - 컴포넌트 props
 * @param {string} props.src - 이미지 URL
 * @param {string|number} props.id - 이미지 고유 식별자
 * @param {Function} [props.deleteImage] - 삭제 콜백 함수 (선택적)
 * @param {string|number} [props.key] - React key prop (선택적)
 *
 * @example
 * // 기본 사용법 (보기 전용)
 * <ImageBox src="/path/to/image.jpg" id="img1" />
 *
 * // 삭제 기능 포함
 * <ImageBox
 *   src="/path/to/image.jpg"
 *   id="img1"
 *   deleteImage={(id) => handleDelete(id)}
 * />
 */

export default function ImageBox(props) {
    const { src, id, deleteImage, key } = props;
    return (
        // <div style={{ position: "relative" }}>
        <div
            style={{
                marginRight: 10,
                width: 90,
                height: 90,
                border: '1px solid #fff',
                borderRadius: 5,
                position: 'relative',
                // display: "flex",
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
            }}
        >
            <Image
                style={{
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                }}
                imgStyle={{ width: '100%', height: '100%', objectFit: 'cover' }}
                src={src}
                alt={`${src}-${id}`}
                preview={{ mask: null, zIndex: 20001 }}
                onError={(e) => {
                    console.log('error', e);
                    e.target.onerror = null;
                    e.target.outerHTML =
                        '<div style="font-size:12px;color:#999;">이미지 없음</div>';
                }}
            />
            {deleteImage && (
                <Icon
                    onClick={() => deleteImage(id)}
                    style={{
                        position: 'absolute',
                        width: 20,
                        height: 20,
                        right: 0,
                        top: 0,
                        cursor: 'pointer',
                    }}
                    src={
                        process.env.PUBLIC_URL +
                        'assets/images/icon/cancel_icon.png'
                    }
                />
            )}
        </div>

        // </div>
    );
}
